<template>
  <div class="modal-overlay" @click.self="handleCloseModal">
    <div class="relative w-full px-6">
      <div class="absolute top-3 right-9 z-10 p-4" @click="handleCloseModal">
        <div class="p-1 bg-tp-yellow rounded-full flex items-center justify-center cursor-pointer">
          <img class="w-3 h-3" :src="close" alt="close-icon">
        </div>
      </div>
      <div class="flex flex-col gap-8 justify-center border-4 border-tp-yellow bg-tp-black rounded-3xl pt-4 pb-6">
        <p class="text-tp-yellow font-bold text-3xl px-6 border-b border-tp-yellow pb-3">{{ t('user.addVotes') }}</p>
        <div class="flex flex-col gap-6 px-6">
          <div 
            v-if="loungeDetails.public.free_songs !== 0" 
            class="flex justify-between gap-1 items-center text-center"
          >
            <div v-if="delayedFree" class="flex gap-2 items-center px-2">
              <p  class="text-sm text-left text-tp-yellow font-semibold max-w-150px">
                {{ t('user.delayedFree') }}
              </p>
              <span class="text-3xl">&#8594;</span>
            </div>
            <p v-else class="flex items-baseline text-sm text-tp-yellow font-semibold text-left">
              <span class="xs:hidden">{{ t('user.youHave') }}</span>
              <span class="hidden xs:flex">{{ t('user.remaining') }}<span v-if="availableFreeSongs !== 1">n </span> </span>
              <span class="text-2xl font-extrabold px-0.5">&nbsp;{{ availableFreeSongs }}&nbsp;</span> 
              {{ t('user.freeVote') }}<span v-if="availableFreeSongs !== 1">s&nbsp;</span>:
            </p>
            <button
              class="bg-tp-yellow text-tp-black font-bold px-2 xs:px-4 py-2 rounded-xl disabled:opacity-50"
              :disabled="availableFreeSongs <= 0 || delayedFree"
              @click="handleFreeVote"
            >
            {{ t('user.free') }}
            </button>
          </div>
          <div v-if="isPromocodeActive" class="flex gap-2 p-2 bg-tp-black border-2 border-tp-yellow rounded-xl text-sm w-full">
            <input 
                type="text" 
                class=" bg-tp-black text-tp-yellow border-none outline-none pl-2 py-1 w-full" 
                :placeholder="t('user.promoPlaceholder')"
                v-model="promocode"               
            />
            <Button 
                class="bg-tp-yellow text-tp-black px-4 py-2 rounded-md font-bold"
                @click="handlePromocode(promocode)"
                :disabled="!isPromocodeValid" 
            >
            {{ t('user.apply') }}
            </Button>
          </div> 
          <AmountSlider class="mb-6" :min="minimumSpending" :max="limitSpending" :step="1" @update:value="handleSliderUpdate" @redirect="handleRedirect"/>
          <div class="flex justify-center items-center gap-1 animate-bounce -ml-6">
            <img class="w-5 h-5" :src="info" alt="">
            <p class="font-bold text-md">{{ t('user.onlyIfPlays') }}</p>
          </div>
        </div>      
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch } from 'vue';
import close from '@/assets/images/black-close-icon.png';
import info from '@/assets/images/info-icon.png';
import AmountSlider from './AmountSlider.vue';
import { setSliderConfig } from '@/utils/sliderConfig';
import { useI18n } from 'vue-i18n';

export default {
  name: 'AddVotesModal',
  props: {
    isAddSong: Boolean,
    votePlans: Object,
    isLoading: Boolean,
    loungeDetails: Object,
  },
  emits: ['onCloseModal', 'submitVotePlan', 'onClickPromocode', 'onClickFreeVote'],
  components: {
    AmountSlider
  },
  setup(props, { emit }) {

    const { t } = useI18n();
    const promocode = ref('');
    const isPromocodeValid = ref(false);
    const isPromocodeActive = ref(props.loungeDetails.public.promos_activas);
    const limitSpending = ref(
      props.loungeDetails.public.limit_spending != null
        ? props.loungeDetails.public.limit_spending - 0.01
        : 99.99
    );
    const minimumSpending = ref(
      props.loungeDetails.public.minimum_spending != null
        ? props.loungeDetails.public.minimum_spending - 0.01
        : 0.99
    );
    const availableFreeSongs = ref(props.loungeDetails.private.availableFreeBoosts);
    const delayedFree = ref(props.loungeDetails.private.delayedFreeBoost);
    setSliderConfig(props.loungeDetails.public.slider_configuration);

    const handleCloseModal = () => {
      emit('onCloseModal');
    };

    const handleSubmitVotePlan = (votePlan) => {
      emit('submitVotePlan', votePlan.price);
    };

    const handleRedirect = (value) => {
      emit('submitVotePlan', value);
    };

    const handlePromocode = (promocode) => {
      emit('onClickPromocode', promocode);
    };

    const handleFreeVote = () => {
      emit('onClickFreeVote');
    };

    watch(promocode, (newVal) => {
      isPromocodeValid.value = newVal.trim().length > 0;
    });

    watch(() => props.loungeDetails, (newVal) => {
      availableFreeSongs.value = newVal?.private?.availableFreeBoosts;
      delayedFree.value = newVal?.private?.delayedFreeBoost;
    }, { deep: true });


    return {
      close,
      info,
      handleCloseModal,
      handleSubmitVotePlan,
      handleRedirect,
      isPromocodeActive,
      isPromocodeValid,
      promocode,
      handlePromocode,
      limitSpending,
      delayedFree,
      availableFreeSongs,
      handleFreeVote,
      t,
      minimumSpending
    }
  }
};

</script>
